export default __webpack_public_path__ + "static/media/already-created.66daaecc.svg";